import { LogLevel } from '@azure/msal-browser';
import { AZUREKEYS } from '../constant/constant';


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

// Azure AD B2C Coordinates
// export const b2cPolicies = {
//     names: {
//         signUpSignIn: "B2C_1_signupsignin1",
//         forgotPassword: "B2C_1_passwordreset1",
//         editProfile: "B2C_1_profileediting1"
//     },
//     authorities: {
//         signUpSignIn: {
//             authority: "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/B2C_1_signupsignin1",
//         },
//         forgotPassword: {
//             authority: "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/B2C_1_passwordreset1",
//         },
//         editProfile: {
//             authority: "https://fabrikamb2c.b2clogin.com/fabrikamb2c.onmicrosoft.com/B2C_1_profileediting1"
//         }
//     },
//     authorityDomain: "fabrikamb2c.b2clogin.com"
// };

export const msalConfig = {
    auth: {
        clientId: AZUREKEYS.REACT_APP_AZURE_CLIENT_ID,
        authority: AZUREKEYS.REACT_APP_AZURE_AUTHORITY,
        redirectUri: AZUREKEYS.REACT_APP_REDIRECT_URI,
        postLogoutRedirectUri: AZUREKEYS.REACT_APP_POST_LOGOUT_REDIRECT_URI,
        // Replace with your Azure AD tenant ID and client ID
        // clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "your-client-id-here", // This is the ONLY mandatory field that you need to supply.
        // authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/your-tenant-id", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        // redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000", // You must register this URI on Azure Portal/App Registration.
        // postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "http://localhost:3000", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set to true to handle crypto API issues and IE11/Edge compatibility
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        },
        windowHashTimeout: 60000, // 60 seconds
        iframeHashTimeout: 6000,   // 6 seconds
        loadFrameTimeout: 0,       // No timeout for frame loading
        navigateFrameWait: 0,      // No wait time for frame navigation
        allowNativeBroker: false,  // Disable native broker to avoid crypto issues
        cryptoOptions: {
            useMsalCrypto: false,  // Fallback to cookie-based auth state storage
            osBrowserCryptoOnly: false
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
